import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsW3cComponent } from './simple-icons-w3c.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsW3cComponent ],
    exports:      [ SimpleIconsW3cComponent ],
    bootstrap:    []
})
export class SimpleIconsW3cModule {}
